import { render, staticRenderFns } from "./driverBasealaryDialog.vue?vue&type=template&id=6db07ad0&scoped=true&"
import script from "./driverBasealaryDialog.vue?vue&type=script&lang=js&"
export * from "./driverBasealaryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db07ad0",
  null
  
)

export default component.exports